export default "__VITE_ASSET__m93xmjXC__"